import React from 'react';
import PropTypes from 'prop-types';
import {
  TextInput,
  SimpleShowLayout,
  AutocompleteInput,
  BooleanInput,
  FormDataConsumer,
  DisabledInput,
} from 'react-admin';
import Header from '../../../shared/header';
import { countryAlpha2List, getCountryName } from '../../../shared/country';
import { maxLength, nonEmptyString, required } from '../../../core/validators';

export const BusinessAddress = ({ resource, classes, isItaly }) => (
  <SimpleShowLayout resource={resource}>
    <Header label="resources.business.businessAddress" />
    <TextInput
      source="address.streetName"
      validate={[required, maxLength(128)]}
      required
      className={classes.field}
      id="Selenium-Business-Create-Address-streetName-Input"
    />
    <TextInput
      source="address.postalCode"
      validate={[required, maxLength(32)]}
      required
      className={classes.field}
      id="Selenium-Business-Create-Address-postalCode-Input"
    />
    <TextInput
      source="address.city"
      validate={[required, maxLength(128)]}
      required
      className={classes.field}
      id="Selenium-Business-Create-Address-City-Input"
    />
    <AutocompleteInput
      source="address.countryCode"
      validate={[required, maxLength(2)]}
      choices={countryAlpha2List}
      className={classes.field}
      autoComplete="nope"
      options={{ required: true }}
      id="Selenium-Business-Create-Address-Country-Input"
      label="resources.business.fields.address.country"
    />
    {isItaly && (
      <TextInput
        source="address.region"
        label="resources.business.fields.mainRegion"
        validate={[required, nonEmptyString, maxLength(64)]}
        className={classes.field}
        required
        id="businessMainAddress"
      />
    )}
    <BooleanInput
      source="useAsBillingAddress"
      className={classes.fullWidth}
      id="Selenium-Business-Create-Address-useAsBillingAddress-Input"
    />
    <FormDataConsumer>
      {({ formData }) =>
        formData.useAsBillingAddress && (
          <React.Fragment>
            <DisabledInput
              resource={resource}
              source="address.streetName"
              required
              validate={[required, maxLength(128)]}
              className={classes.field}
              id="Selenium-Business-Create-Address-useAsBillingAddress-StreetName-Input"
            />
            <DisabledInput
              resource={resource}
              source="address.postalCode"
              required
              validate={[required, maxLength(32)]}
              className={classes.field}
            />
            <DisabledInput
              resource={resource}
              source="address.city"
              required
              validate={[required, maxLength(128)]}
              className={classes.field}
            />
            {/* Mirrors the main address country: it must keep the same validators, otherwise
                registering this field drops the required rule from address.countryCode. */}
            <DisabledInput
              resource={resource}
              source="address.countryCode"
              label="resources.business.fields.billingAddress.country"
              validate={[required, maxLength(2)]}
              required
              format={getCountryName}
              className={classes.field}
              id="Selenium-Business-Create-Address-useAsBillingAddress-Country-Input"
            />
            {isItaly && (
              <DisabledInput
                source="address.region"
                label="resources.business.fields.invoicingRegion"
                validate={[required, nonEmptyString, maxLength(64)]}
                className={classes.field}
                required
                id="businessInvoicingAddress"
              />
            )}
          </React.Fragment>
        )
      }
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData }) =>
        formData.useAsBillingAddress !== true && (
          <React.Fragment>
            <TextInput
              resource={resource}
              source="billingAddress.streetName"
              required
              validate={[required, maxLength(128)]}
              className={classes.field}
              id="Selenium-Business-Create-Address-notUseAsBillingAddress-StreetName-Input"
            />
            <TextInput
              resource={resource}
              source="billingAddress.postalCode"
              required
              validate={[required, maxLength(32)]}
              className={classes.field}
            />
            <TextInput
              resource={resource}
              source="billingAddress.city"
              required
              validate={[required, maxLength(128)]}
              className={classes.field}
            />
            <AutocompleteInput
              resource={resource}
              source="billingAddress.countryCode"
              validate={[required, maxLength(2)]}
              choices={countryAlpha2List}
              className={classes.field}
              autoComplete="nope"
              options={{ required: true }}
              label="resources.business.fields.billingAddress.country"
              id="Selenium-Business-Create-Address-notUseAsBillingAddress-Country-Input"
            />
            {isItaly && (
              <TextInput
                source="billingAddress.region"
                label="resources.business.fields.invoicingRegion"
                validate={[required, nonEmptyString, maxLength(64)]}
                className={classes.field}
                required
                id="businessInvoicingAddress"
              />
            )}
          </React.Fragment>
        )
      }
    </FormDataConsumer>
  </SimpleShowLayout>
);

BusinessAddress.propTypes = {
  classes: PropTypes.shape({}),
  resource: PropTypes.string,
  isItaly: PropTypes.bool,
};
